import React, { useState } from 'react'
import { GoogleLogin } from '@react-oauth/google';
import { Link } from 'react-router-dom';
import { HiArrowLeft } from 'react-icons/hi2';
import { jwtDecode } from "jwt-decode";
import { useGoogleLogin } from '@react-oauth/google';
import { FaPhone } from 'react-icons/fa';
import { MdErrorOutline } from 'react-icons/md';
import { IoCheckmarkDoneCircle } from 'react-icons/io5';
import axios from 'axios';
import Modal from '../../controls/Modal';
import Input from '../../controls/Input';
import LodingButton from '../../controls/LodingButton';
import LoadingContainer from '../../controls/LoadingContainer';
import useAuth from '../../../configurations/auth/publicUsers/useAuth';
import { useToast } from '../../controls/Toast/ToastService';
import { GoogleOAuth, GoogleOAuthPublicUserCreate } from '../../../configurations/crud/publicUserCrud';
import FooterInner from '../../base/FooterInner';
import useRegisterPush from '../../../configurations/push/pushNotification';
import {
    GoogleAuthProvider,
    signInWithPopup,
} from "firebase/auth";
import { auth } from '../../../configurations/firebase';
import { Capacitor } from '@capacitor/core';
import { FirebaseAuthentication } from '@capacitor-firebase/authentication';

export default function PublicUserOAuth() {
    const { logedIn } = useAuth()
    const [isLoading, setIsLoading] = useState(false)
    const [isNewUser, setIsNewUser] = useState(false)
    const [phoneNo, setPhoneNo] = useState("")
    const toast = useToast()
    const { handleRegister } = useRegisterPush()

    const getGoogleIdToken = async () => {
        if (Capacitor.isNativePlatform()) {
            // Native: plugin seedha Google ID token deta hai
            const result = await FirebaseAuthentication.signInWithGoogle({
                scopes: ['profile', 'email'],
            });
            return result.credential?.idToken;            // ✅ Google ID token
        } else {
            // Web: popup result se Google credential ka idToken nikaalo
            const provider = new GoogleAuthProvider();
            const result = await signInWithPopup(auth, provider);
            const credential = GoogleAuthProvider.credentialFromResult(result);
            return credential.idToken;                     // ✅ Google ID token
        }
    }
    const handleChange = (event) => {
        const inputValue = event.target.value;
        if (/^\d*$/.test(inputValue) || inputValue === '') {
            if (inputValue.length <= 10)
                setPhoneNo(inputValue);
        }
    };

    // const handleLogin = async () => {
    //     setIsLoading(true)
    //     try {
    //         const provider = new GoogleAuthProvider();

    //         const result = await signInWithPopup(
    //             auth,
    //             provider
    //         );

    //         // Firebase User
    //         const user = result.user;

    //         // Firebase Token
    //         const token = await user.getIdToken();

    //         GoogleOAuth({ token: token })
    //             .then(res => {
    //                 let resultX = res.data.result
    //                 if (resultX.succeeded) {
    //                     const { token, result, ...newdata } = res.data
    //                     logedIn({
    //                         isLogin: true,
    //                         data: { ...newdata },
    //                         token: token
    //                     }, handleRegister)
    //                 }
    //                 else {
    //                     toast.open("Login Failed: Create user for login.", <MdErrorOutline />, "danger")
    //                 }
    //                 setIsLoading(false)
    //             }).catch(err => {
    //                 setIsLoading(false)
    //                 toast.open("Login Failed.", <MdErrorOutline />, "danger")
    //             })
    //     }
    //     catch (err) {
    //         toast.open("Login Failed", "text-red-400", <MdErrorOutline />)
    //         setIsLoading(false)
    //     }
    // }
    const handleLogin = async () => {
        setIsLoading(true);
        try {
            const token = await getGoogleIdToken();
            GoogleOAuth({ token })
                .then(res => {
                    let resultX = res.data.result;
                    if (resultX.succeeded) {
                        const { token, result, ...newdata } = res.data;
                        logedIn({ isLogin: true, data: { ...newdata }, token }, handleRegister);
                    } else {
                        toast.open("Login Failed: Create user for login.", <MdErrorOutline />, "danger");
                    }
                    setIsLoading(false);
                })
                .catch(err => {
                    alert(JSON.stringify(err))
                    setIsLoading(false);
                    toast.open("Login Failed.", <MdErrorOutline />, "danger");
                });
        } catch (err) {
            toast.open("Login Failed", <MdErrorOutline />, "danger");
            setIsLoading(false);
        }
    }

    const handleLoginWithCreateUser = async () => {
        setIsLoading(true)
        try {
            const token = await getGoogleIdToken();
            GoogleOAuthPublicUserCreate({ token: token, phoneNo: phoneNo })
                .then(res => {
                    let resultX = res.data.result
                    if (resultX.succeeded) {
                        const { token, result, ...newdata } = res.data
                        logedIn({
                            isLogin: true,
                            data: { ...newdata },
                            token: token
                        }, handleRegister)
                        toast.open("User created and Logged In.", <IoCheckmarkDoneCircle />, "success")
                    }
                    else {
                        toast.open("Login Failed", <MdErrorOutline />, "danger")
                    }
                    setIsLoading(false)
                }).catch(err => {
                    alert(JSON.stringify(err))
                    setIsLoading(false)
                    toast.open("Ex. Login Failed.", <MdErrorOutline />, "danger")
                })
        }
        catch (err) {
            toast.open("Login Failed", "text-red-400", <MdErrorOutline />)
            setIsLoading(false)
        }
    }

    return (
        <div className="min-h-screen flex flex-col justify-between bg-gray-100">
            <section className="relative overflow-hidden px-6 pt-6 pb-12 lg:px-20 text-center bg-gradient-to-br from-brand-500 via-brand-500 to-blue-800">
                <div className="absolute -top-20 -right-16 h-60 w-60 rounded-full bg-white/10 blur-2xl" />
                <Link to="/" className="absolute left-4 top-4 inline-flex items-center gap-1.5 text-sm font-medium text-white/90 bg-white/15 hover:bg-white/25 rounded-xl px-3 py-1.5 transition">
                    <HiArrowLeft /> Back
                </Link>
                <img alt="Doctora OPD" src="/assets/images/logo-white.svg" className="relative mx-auto h-9 w-auto animate-fade-up" />
                <p className="relative text-sm max-w-3xl mx-auto mt-3 sm:text-base text-white/85 font-medium animate-fade-up">
                    <p className="text-sm max-w-3xl mx-auto mb-4 sm:text-lg text-gray-700 italic font-semibold opacity-0 animate-fade-in delay-[0ms]">
                        <span className='text-white'>Digital</span> OPD to <span className='text-white'>Connect</span> with <span className='text-red-500'>Doctors</span>, manage schedules, and simplify healthcare.
                    </p>
                </p>
            </section>

            <div className="grow flex items-center justify-center px-4 -mt-6">
                <div className="w-full max-w-5xl grid md:grid-cols-2 gap-12 items-center">

                    <div className="card-surface p-8 md:p-10 animate-fade-up">

                        {
                            isLoading ?
                                <div className='py-12'>
                                    <LoadingContainer text='Logging in...' />
                                </div>
                                :
                                isNewUser ?
                                    <div>
                                        <h2 className="text-2xl font-semibold text-gray-900">
                                            Create account
                                        </h2>

                                        <p className="text-sm text-gray-500 mt-2 mb-6">
                                            Enter your mobile number to continue
                                        </p>

                                        <div>
                                            <label htmlFor='phoneNo' className="text-sm font-medium text-gray-700">
                                                Mobile number
                                            </label>

                                            <div className="mt-2">
                                                <Input
                                                    IsError={!phoneNo}
                                                    Icon={<FaPhone className='text-green-500' />}
                                                    id='phoneNo'
                                                    placeholder="10 digit mobile number"
                                                    value={phoneNo}
                                                    onChange={handleChange}
                                                />
                                            </div>
                                        </div>

                                        <div className='mt-6 flex justify-center'>
                                            {phoneNo.length != 10 ?
                                                // <LodingButton isDisabled={phoneNo.length != 10}>
                                                //     Continue
                                                // </LodingButton>
                                                <button className='btn-blue-disabled'>Create User</button>
                                                :
                                                <button className='btn-blue' onClick={handleLoginWithCreateUser}>Create User</button>
                                                // <GoogleLogin
                                                //     onSuccess={credentialResponse => {
                                                //         handleLoginWithCreateUser(credentialResponse.credential)
                                                //     }}
                                                //     onError={() => {
                                                //         toast.open("Login Failed", "text-red-400", <MdErrorOutline />)
                                                //     }}
                                                // />
                                            }
                                        </div>

                                        <div className='mt-6 text-center'>
                                            <button
                                                onClick={() => setIsNewUser(false)}
                                                className='text-brand-500 hover:underline text-sm font-medium'
                                            >
                                                Back to Login
                                            </button>
                                        </div>
                                    </div>
                                    :
                                    <div>
                                        <h2 className="text-2xl font-semibold text-gray-900">
                                            Login as Public User
                                        </h2>

                                        <p className="text-sm text-gray-500 mt-2 mb-8">
                                            Continue with Google to access your account
                                        </p>

                                        <div className='flex justify-center'>
                                            <button className='btn-blue' onClick={handleLogin}>Google Login</button>
                                            {/* <GoogleLogin
                                                onSuccess={credentialResponse => {
                                                    handleLogin(credentialResponse.credential)
                                                }}
                                                onError={() => {
                                                    toast.open("Login Failed", "text-red-400", <MdErrorOutline />)
                                                }}
                                            /> */}
                                        </div>

                                        <div className='mt-8 text-center'>
                                            <button
                                                onClick={() => setIsNewUser(true)}
                                                className='text-brand-500 hover:underline text-sm font-medium'
                                            >
                                                Create new User?
                                            </button>
                                        </div>
                                    </div>
                        }
                    </div>
                    <div className="pb-6">
                        <h1 className="text-4xl font-bold text-gray-900 leading-tight">
                            Healthcare made
                            <span className="text-brand-500"> simple</span>
                        </h1>

                        <p className="mt-4 text-gray-600 leading-7 max-w-md">
                            Discover doctors, book appointments and manage your healthcare journey with a simple and fast experience.
                        </p>


                    </div>
                </div>
            </div>

            <section>
                <FooterInner />
            </section>
        </div>
    )
}